import { RxGear } from '@react-icons/all-files/rx/RxGear'
import * as React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { createNewShortlist } from '@disco/state-management/actions/ShortlistActions'
import { getShortlistByPlaylistId } from '@disco/state-management/selectors/shortlists'

import type { Playlist } from 'types/playlist'

import { getShortlistBaseRoute } from 'utils/routing'

import { DropdownMenu, Flex } from 'components/ds'
import Tooltip from 'components/ui/tooltip'

import { useDispatch, useSelector } from 'hooks/use-redux'

type Props = {
  playlist: Playlist
  onNeedsAwait: () => void
}

const PlaylistSettings = ({
  playlist,
  onNeedsAwait,
}: Props): React.ReactNode => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const shortlist = useSelector(state =>
    getShortlistByPlaylistId(state, playlist.playlist_id),
  )
  const shortlistEmpty = shortlist?.items?.length === 0

  const tooltipContent = shortlistEmpty
    ? 'Add tracks to your playlist to edit it.'
    : null

  const onSelect = () => {
    dispatch(createNewShortlist(playlist))
    if (shortlist && !shortlistEmpty) {
      // Shortlist already exists with items — navigate immediately
      const baseRoute = getShortlistBaseRoute(location)
      navigate(`${baseRoute}/shortlists/${shortlist.id}/save`, {
        state: { location: 'playlist_settings' },
      })
    } else if (!shortlist) {
      // Shortlist is being created — parent handles navigation once it's ready
      onNeedsAwait()
    }
    // Shortlist exists but is empty: item is disabled, onSelect won't fire
  }

  return (
    <Tooltip content={tooltipContent} position="bottom">
      <DropdownMenu.Item disabled={shortlistEmpty} onSelect={onSelect}>
        <Flex align="center" gap="2">
          <RxGear />
          Playlist Settings
        </Flex>
      </DropdownMenu.Item>
    </Tooltip>
  )
}

export default PlaylistSettings
